import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Error500 = () => {
  const { t } = useTranslation();
   return (
      <div className="authincation h-100">
         <div className="container vh-100">
            <div className="row justify-content-center h-100 align-items-center">
               <div className="col-md-5">
                  <div className="form-input-content text-center error-page">
                     <h1 className="error-text font-weight-bold">500</h1>
                     <h4>
                        <i className="fa fa-times-circle text-danger" />{t("pages.errors.e500.internalServerError")}
                     </h4>
                     <p>{t("pages.errors.e500.youDoNotHavePermissionTo")}</p>
                     <div>
                        <Link className="btn btn-primary" to="/dashboard">
                           {t("common.ui.backToHome")}
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error500;
